import React from "react"
import { GridLines, Headline, Analytics } from "@shared"
import { css, randomInt } from "@jsUtils"

import { PageSection } from "../PageSection"

import Styles from "./contactEmails.module.scss"

const TrackedLink = Analytics("a")

/**
 * ContactEmails section
 * @param {object} props - React props
 */
const ContactEmails = props => {
  const { theme, contacts } = props
  const [ready, setReady] = React.useState(false)
  const emails = contacts.map(contact => {
    return (
      <div className={Styles.contact} key={randomInt(0, Date.now())}>
        <Headline className={Styles.contactTitle} size={5}>
          {contact.title}
        </Headline>
        <p className={Styles.contactDescription}>{contact.description}</p>
        <TrackedLink
          ascope="CONTACT"
          adata={{
            content: contact.email
          }}
          className={Styles.contactEmail}
          href={`mailto:${contact.email}`}
        >
          {contact.email}
        </TrackedLink>
      </div>
    )
  })
  return (
    <PageSection
      className={css(Styles.section, Styles[`theme_${theme}`], ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <div className={Styles.content}>{emails}</div>
    </PageSection>
  )
}

export default ContactEmails
